import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { translate, DashboardMenuItem, MenuItemLink } from 'admin-on-rest';

import PagesIcon from 'material-ui/svg-icons/social/pages';
import CompanyIcon from 'material-ui/svg-icons/action/home';
import BranchIcon from 'material-ui/svg-icons/action/extension';
import DeshcriptionIcon from 'material-ui/svg-icons/action/description';
import QuestionIcon from 'material-ui/svg-icons/action/assessment';
import OximataIcon from 'material-ui/svg-icons/maps/local-taxi';
import ProductIcon from 'material-ui/svg-icons/action/card-membership';
import AdminIcon from 'material-ui/svg-icons/social/people';
import UserIcon from 'material-ui/svg-icons/social/person';
import SettingsIcon from 'material-ui/svg-icons/action/settings';

var type_user=localStorage.getItem('permissions');
var company_name=localStorage.getItem('company_name');
var image=localStorage.getItem('image');
var quiz_box=localStorage.getItem('quiz_box');
var sxolia=localStorage.getItem('sxolia');

console.log("quiz_box",quiz_box);

var companies,change,complaints,quizbox;

var editText, style;



if(type_user === "SuperUser"){
  companies = [
        { name: 'admins', icon: <AdminIcon /> },
        { name: 'users', icon: <UserIcon /> },
        { name: 'categories', icon: <CompanyIcon /> },
        { name: 'companies', icon: <CompanyIcon /> },
        { name: 'branches', icon: <BranchIcon /> },
      { name: 'oximata', icon: <OximataIcon /> }
  ];
}else{
  companies = [];
}

if(quiz_box === "true" || type_user === "SuperUser"){

   change = [
        { name: 'product', icon: <ProductIcon /> },

        { name: 'news', icon: <DeshcriptionIcon /> }
  ];

  quizbox = [
          { name: 'survey', icon: <QuestionIcon /> },
          { name: 'answers', icon: <QuestionIcon /> }
 ];



   complaints = [
        { name: 'complaint', icon: <PagesIcon /> },

  ];

}else{

  quizbox = [];

   change = [
        { name: 'product', icon: <ProductIcon /> },
        { name: 'news', icon: <DeshcriptionIcon /> }
  ];

   complaints = [
        { name: 'complaint', icon: <PagesIcon /> }
  ];
}


const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: '100%',
    },
    make_space: {
      textAlign: 'center',
      marginTop: "20px",
      color:"#27BCD3"
    },
    sxolia_space: {
      textAlign: 'center',
      marginTop: "20px",
      fontSize:"20px",
      fontWeight:"Bold"
    },
    line: {
    display: 'block',
    height: '1px',
    border: 0,
    borderTop: '1px solid #000',
    margin: "1em 0",
    padding: 0
},
float_left: {
  float: "left"

},
image_size:{
  width: "80%",
  margin: "0 auto",
  display: "block",
  verticalAlign:"middle"
},
display_none:{
  display:"none"
}

};

if(type_user === "SuperUser" || quiz_box === "true"){
 editText = "Quizbox"
 style=styles.line
}else{
 editText = ""
 style=styles.display_none
}

const Menu = ({ onMenuTap, translate, logout }) => (
    <div style={styles.main}>

    <div>
    <p  ><img alt="" style={styles.image_size} src={image} /></p>
    <h1 style={styles.make_space}>{company_name}</h1>
    <p style={styles.sxolia_space}>{translate('resources.users.name')} {sxolia} </p>
    </div>
        <DashboardMenuItem onClick={onMenuTap} />
        {companies.map(item => (
            <MenuItemLink
                key={item.name}
                to={`/${item.name}`}
                primaryText={translate(`resources.${item.name}.name`, { smart_count: 2 })}
                leftIcon={item.icon}
                onClick={onMenuTap}
            />
        ))}

        <hr style={styles.line} />
        <h3 style={styles.make_space}>{translate('resources.edit.name')}</h3>


        {change.map(item => (
            <MenuItemLink
                key={item.name}
                to={`/${item.name}`}
                primaryText={translate(`resources.${item.name}.name`, { smart_count: 2 })}
                leftIcon={item.icon}
                onClick={onMenuTap}
            />
        ))}

          <hr style={style} />
          <h3 style={styles.make_space}>{editText}</h3>

          {quizbox.map(item => (
              <MenuItemLink
                  key={item.name}
                  to={`/${item.name}`}
                  primaryText={translate(`resources.${item.name}.name`, { smart_count: 2 })}
                  leftIcon={item.icon}
                  onClick={onMenuTap}
              />
          ))}

        <hr style={styles.line} />
        <h3 style={styles.make_space}> {translate('resources.comments.name')} </h3>


        {complaints.map(item => (
            <MenuItemLink
                key={item.name}
                to={`/${item.name}`}
                primaryText={translate(`resources.${item.name}.name`, { smart_count: 2 })}
                leftIcon={item.icon}
                onClick={onMenuTap}
            />
        ))}
        {logout}
    </div>
);

const enhance = compose(
    connect(state => ({
        theme: state.theme,
        locale: state.locale,
    })),
    translate,
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/Menu.js